import { Box, Typography, tokensRaw } from '@vp/swan';
import styled from 'styled-components';
import { __ } from '@99designs/i18n';

const ComboboxPopoverContent = styled(Box)`
    padding: ${tokensRaw.SwanCompListboxOptionPaddingHorizontal}
        calc(
            ${tokensRaw.SwanCompListboxPadding} +
                ${tokensRaw.SwanCompListboxOptionPaddingHorizontal}
        )
        0
        calc(
            ${tokensRaw.SwanCompListboxPadding} +
                ${tokensRaw.SwanCompListboxOptionPaddingHorizontal}
        );
`;

interface ComboBoxHeaderProps {
    hasResults: boolean;
    hasSearched: boolean;
}

export const ComboBoxResultsHeader = ({ hasResults, hasSearched }: ComboBoxHeaderProps) => {
    return (
        <ComboboxPopoverContent>
            {hasSearched && !hasResults && (
                <>
                    <Typography fontSkin="title-item">{__('No Results Found')}</Typography>
                    <Typography paddingBottom="7">
                        {__('We’re sorry, we couldn’t find any results based on your search.')}
                    </Typography>
                    <Typography fontSkin="title-item">{__('Popular design services')}:</Typography>
                </>
            )}
            {!hasSearched && !hasResults && (
                <Typography fontSkin="title-item">{__('Trending searches')}:</Typography>
            )}
            {hasResults && (
                <Typography fontSkin="title-item">{__('Most relevant results')}:</Typography>
            )}
        </ComboboxPopoverContent>
    );
};
